import { render } from "./KnPerspectiveCard.vue?vue&type=template&id=e60f5d90&ts=true"
import script from "./KnPerspectiveCard.vue?vue&type=script&lang=ts"
export * from "./KnPerspectiveCard.vue?vue&type=script&lang=ts"

import "./KnPerspectiveCard.vue?vue&type=style&index=0&id=e60f5d90&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__